import { useEffect, useRef } from 'react';

import { getOrientation } from '@ezugi/utils/helpers/getOrientation';

import { setViewportSizeVariables } from '../util/viewport';

export default function useRotateViewportSizeVariables() {
  const orientationRef = useRef(getOrientation());

  useEffect(() => {
    function update() {
      const next = getOrientation();

      if (next !== orientationRef.current) {
        orientationRef.current = next;
        setViewportSizeVariables();
      }
    }

    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('resize', update);
    };
  }, []);
}
